import { createContext, useContext } from 'react';

export type DataPlusEmbargoContextType = {
  availableSelectedYear: number;
  availableYearOnYears: number[];
  availableEmbargoYears: number[];
  canViewMainEmbargo: boolean;
  canViewFreeEmbargo: boolean;
};

export const defaultContextValue = {
  availableSelectedYear: new Date().getFullYear(),
  availableYearOnYears: [new Date().getFullYear()],
  availableEmbargoYears: [new Date().getFullYear()],
  canViewMainEmbargo: false,
  canViewFreeEmbargo: false,
};

export const DataPlusEmbargoContext = createContext<DataPlusEmbargoContextType>(
  defaultContextValue,
);

export const useDataplusEmbargoData = () => useContext(DataPlusEmbargoContext);
